export default __webpack_public_path__ + "static/media/barcode.349a4f96.svg";